angular.module('tgaAdmin').controller('HubAddTaskActivityController', [
  '$scope',
  '$state',
  '$window',
  '$uibModalInstance',
  '$uibModalStack',
  'tzService',
  'extras',
  '$filter',
  function ($scope, $state, $window, $uibModalInstance, $uibModalStack, tzService, extras, $filter) {
    $scope.showComingTooltip = $filter('translate')('modal.show_coming_tooltip');
    $scope.data = {
      alerts: [],
      closeButton: true,
      hubId: extras.hubId,
      disable_featured: extras.items_featured >= 3,
      activityTypes: [
        { id: 'pdf', name: 'PDF' },
        { id: 'image', name: 'Image' },
        { id: 'video', name: 'Video' },
        { id: 'link', name: 'URL' },
        { id: 'audio', name: 'Audio' },
      ],
      dataTypes: [
        { id: 'iframe', name: 'Arcade (iframe)' },
        { id: 'external', name: 'New browser tab' },
      ],
    };

    $scope.viewmodel = {
      // Activity Details
      hub_activity_id: null, // for existing tasks
      hub_id: $scope.data.hubId,
      activity_type: null,
      tile_image: null,
      tile_color: null,
      // Task Details
      name: null,
      data: null,
      data_type: null,
      // Timer Details
      start_date: null,
      end_date: null,
      coming_soon: null,
      // Featured Details
      is_featured: null,
      featured_text: null,
    };

    $scope.initialize = function () {
      // Parse date to user's timezone
      if ($scope.viewmodel.start_date) {
        $scope.viewmodel.start_date = tzService.parseUserDate($scope.viewmodel.start_date);
      }

      if ($scope.viewmodel.end_date) {
        $scope.viewmodel.end_date = tzService.parseUserDate($scope.viewmodel.end_date);
      }

      $scope.viewmodel.coming_soon = !!$scope.viewmodel.coming_soon;
    };

    $scope.actions = {
      submit(form) {
        form.submitted = true;

        $scope.actions.clearAlerts();

        if (form.$invalid) {
          return;
        }

        $scope.loading = true;
        $uibModalStack.getTop().value.backdrop = 'static';
        $uibModalStack.getTop().value.keyboard = false;

        // Date gets set to `true` when you clear the field
        if ($scope.viewmodel.start_date === true) {
          $scope.viewmodel.start_date = null;
        }

        if ($scope.viewmodel.end_date === true) {
          $scope.viewmodel.end_date = null;
        }

        // Convert date back to UTC for storing in the database
        if ($scope.viewmodel.start_date) {
          $scope.viewmodel.start_date = $scope.viewmodel.start_date.utc().format();
        }

        if ($scope.viewmodel.end_date) {
          $scope.viewmodel.end_date = $scope.viewmodel.end_date.utc().format();
        }

        if ($scope.viewmodel.tile_color && $scope.viewmodel.tile_color.length !== 7) {
          $scope.viewmodel.tile_color = null;
        }

        $uibModalInstance.close($scope.viewmodel);
      },
      changeActivityType(item) {
        item.file = null;
        item.data = null;
        item.data_type = null;
        if (item.activity_type === 'link' && item.data_type !== 'external') {
          item.data_type = 'iframe';
        }
      },
      checkImage(image) {
        $scope.actions.clearAlerts();

        if (!image) {
          $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Invalid file format or file exceeds file size limit.',
            'danger',
          );
          return;
        }

        const extension = /(?:\.([^.]+))?$/;
        const ext = extension.exec(image.filename)[1];
        const allowed = /jpeg|jpg|gif|png|svg|pdf|mpg|mpeg|mp4|avi|mp3/i;
        if (!allowed.test(ext)) {
          $scope.viewmodel.data = null;
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        // Don't allow images larger than 10MB.
        if (image.filesize > 10485760) {
          $scope.viewmodel.data = null;
          $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Image files cannot be more than 10 MB in size.',
            'danger',
          );
        }
      },
      forceHex() {
        if ($scope.viewmodel.tile_color[0] !== '#') {
          $scope.viewmodel.tile_color = `#${$scope.viewmodel.tile_color}`;
        }
      },
      videoEmbed(item) {
        if (item.data.includes('vimeo')) {
          const result = item.data.match(
            // eslint-disable-next-line max-len
            /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/i,
          );
          item.data = `https://player.vimeo.com/video/${result[1]}`;
        } else if (item.data.includes('youtu')) {
          if (!item.data.includes('embed')) {
            const expr = /(youtu\.be\/|[?&]v=)([^&]+)/;
            item.data = `https://www.youtube.com/embed/${item.data.match(expr)[2]}`;
          }
        }
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
      clearAlerts() {
        $scope.data.alerts = [];
      },
      close() {
        $uibModalInstance.dismiss();
      },
    };
    $scope.initialize();
  },
]);
